export enum ResumeProcessLinkDestination {
  OtpVerification = 'OtpVerification',
  Login = 'Login',
}
